import React, { useState, useContext, useEffect, useRef } from "react";
import Context from "@components/useContext/context";

import {
  Input,
  Label,
  InputWrapper,
  Note,
  ErrorText,
  DropDown,
  MobilePrefix,
  StyledLocationIcon,
  StyledCalendarIcon,
  StyledCrossIcon
} from "./styles";
import { INPUT_FIELDS_TRIM_NOT_REQUIRED } from "@utils/index";
// import { $space } from "@acko-tech/building-blocks.ui.common";

const InputField = ({
  value,
  touched,
  errors,
  handleChange,
  handleBlur,
  placeholder,
  name,
  note,
  type,
  onChange,
  readOnly,
  handleClick,
  showError,
  setShowError,
  autoCapitalize,
  className,
  dropdown,
  dropdownStyles,
  autoFocus,
  inputStyles,
  disabled,
  hideLabelText,
  customHandleBlur,
  inputContainerStyles,
  location,
  autoComplete,
  onFocus,
  mobilePrefix = false,
  Icon,
  calendarIcon,
  showCrossIcon,
  height,
  onKeyDown
  // labelStyle
}: //prop
any) => {
  const { isDesktop } = useContext(Context);
  const [focused, setFocused] = useState(false);
  const [isAutoFocused, setisAutoFocused] = useState(false);
  const inputEl = useRef(null);

  useEffect(() => {
    if (autoFocus && !isAutoFocused && inputEl !== null) {
      (inputEl as any).current.focus();
      setisAutoFocused(true);
    }
  }, [autoFocus]);

  const handleCrossClick = e => {
    e.preventDefault();
    value = "";
    onChange(value);
  };
  return (
    <InputWrapper isDesktop={isDesktop} styles={inputContainerStyles}>
      {location && <StyledLocationIcon onClick={handleClick} />}
      <div style={{ position: "relative" }}>
        <Input
          isPrefix={mobilePrefix}
          ref={inputEl}
          placeholder={placeholder}
          id={name}
          key={name}
          type={type || "text"}
          name={name}
          value={value || ""}
          autoComplete={autoComplete}
          onChange={e => {
            if (handleChange) handleChange(e);
            if (showError) setShowError(false);
            let value = autoCapitalize
              ? e.target.value.toUpperCase()
              : e.target.value;
            value = INPUT_FIELDS_TRIM_NOT_REQUIRED.includes(name)
              ? value
              : value.trim();
            onChange && onChange(value); // eslint-disable-line
          }}
          onBlur={e => {
            if (handleBlur) handleBlur(e);
            if (customHandleBlur) customHandleBlur(e);
            setFocused(false);
          }}
          onFocus={() => {
            onFocus && onFocus();
            setFocused(true);
          }}
          isError={errors[name] && touched[name]}
          readOnly={readOnly || false}
          autoCapitalize={autoCapitalize}
          onClick={handleClick}
          className={className}
          isDesktop={isDesktop}
          pointerCursor={dropdown || location}
          styles={inputStyles}
          disabled={disabled}
          height={height}
          onKeyDown={onKeyDown}
        />
        {mobilePrefix && <MobilePrefix>+91</MobilePrefix>}
        {Icon}
        <Label focused={focused}>{hideLabelText ? "" : placeholder}</Label>
        {/* <Label focused={focused} style={labelStyle}>{hideLabelText ? "" : placeholder}</Label> */}
      </div>
      {(showError || (errors[name] && touched[name])) && (
        <ErrorText
          isDesktop={isDesktop}
          size="xxs"
          margin={"4px 0px"}
          // margin={isDesktop ? `0.05rem 1.1em 0.5rem` : `${$space.xs} 1.1em 0`}
        >
          {errors[name]}
        </ErrorText>
      )}
      {note && (
        <Note isDesktop={isDesktop} error={errors[name]}>
          {note}
        </Note>
      )}

      {dropdown && <DropDown style={dropdownStyles} onClick={handleClick} />}
      {calendarIcon && <StyledCalendarIcon onClick={handleClick} />}
      {showCrossIcon && value && <StyledCrossIcon onClick={handleCrossClick} />}
    </InputWrapper>
  );
};

export default InputField;
